export default __webpack_public_path__ + "static/media/point.0084416a.svg";